import React from "react";
import { List, Typography, Button } from "antd";
import { CVInterface } from "api/enumerator/Profile/dto";
import { formatDate } from "utils/date";

const { Text } = Typography;

interface CvItemProp {
    item: CVInterface;
}

export const CvItem: React.FC<CvItemProp> = ({ item }) => {
    let fileUrl: string | null = null;
    let fileName: string | null = null;

    if (typeof item.file === "string") {
        fileUrl = item.file;
        fileName = decodeURIComponent(item.file.split("/").pop() || "CV_File.pdf");
    } else if (Array.isArray(item.file) && item.file.length > 0) {
        fileUrl = item.file[0]?.url || null;
        fileName = item.file[0]?.name || "CV_File.pdf";
    }

    if (!fileUrl) {
        return <Text type="danger">No CV available.</Text>;
    }

    return (
        <List.Item>
            <List.Item.Meta
                description={
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        {item.updatedAt && (
                            <Text type="secondary">Last updated: {formatDate(item.updatedAt)}</Text>
                        )}
                        <div style={{ marginTop: "10px" }}>
                            <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: "none", display: "block" }}
                            >
                                <Button
                                    type="link"
                                    style={{

                                        borderRadius: "5px",
                                        height: "40px",
                                        width: "150px",
                                        fontWeight: "500",
                                    }}
                                >
                                    view in tab
                                </Button>
                            </a>
                        </div>

                        {fileUrl && (
                            <div
                                style={{
                                    marginTop: "10px",
                                    width: "90%",
                                    maxWidth: "800px",
                                    height: "600px",
                                    border: "1px solid #ddd",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    overflow: "hidden",
                                    backgroundColor: "#f8f8f8",
                                }}
                            >
                                <iframe
                                    src={fileUrl}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        border: "none",
                                        objectFit: "cover",
                                    }}
                                    title={`CV Preview - ${fileName}`}
                                />
                            </div>
                        )}
                    </div>
                }
            />
        </List.Item>
    );
};